import { render, staticRenderFns } from "./ExchangeForm.vue?vue&type=template&id=2323663e&scoped=true&"
import script from "./ExchangeForm.vue?vue&type=script&lang=js&"
export * from "./ExchangeForm.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeForm.vue?vue&type=style&index=0&id=2323663e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2323663e",
  null
  
)

export default component.exports